import { CC_PRODUCT_ID, IS_POD, PROJECT_ID, ROLE } from "./Constants"

export const setLocalItem = (item, value) => {
    localStorage.setItem(item, value)
}

export const getLocalItem = (item) => {
    return localStorage.getItem(item)
}

export const removeLocalItem = (item) => {
    localStorage.removeItem(item)
}

export const setSessionItem = (item, value) => {
    sessionStorage.setItem(item, value)
}

export const getSessionItem = (item) => {
    return sessionStorage.getItem(item)
}

export const removeSessionItem = (item) => {
    sessionStorage.removeItem(item)
}

export const setAssetData = (data) => {
    setSessionItem(IS_POD, data?.isPod)
    setSessionItem(CC_PRODUCT_ID, data?.ccproductid)
    setSessionItem(PROJECT_ID, data?.projectid)
    setSessionItem(ROLE, data?.usertype)
}

export const clearAssetData = () => {
    removeSessionItem(IS_POD)
    removeSessionItem(CC_PRODUCT_ID)
    removeSessionItem(PROJECT_ID)
    removeSessionItem(ROLE)
}